var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9038 15.9031C15.0218 16.7852 15.0218 18.2148 15.9038 19.0962C16.7852 19.9782 18.2155 19.9782 19.0969 19.0962C19.9789 18.2141 19.9789 16.7845 19.0969 15.9031C18.2148 15.0218 16.7852 15.0218 15.9038 15.9031ZM17.5 0C7.83478 0 0 7.83478 0 17.5C0 27.1652 7.83478 35 17.5 35C27.1652 35 35 27.1652 35 17.5C35 7.83478 27.1652 0 17.5 0ZM26.401 10.4471L21.7459 20.6331C21.5207 21.1257 21.1257 21.5207 20.6331 21.7459L10.4478 26.401C9.27288 26.938 8.062 25.7271 8.59899 24.5522L13.2548 14.3662C13.48 13.8736 13.875 13.4786 14.3676 13.2534L24.5529 8.59829C25.7278 8.062 26.938 9.27218 26.401 10.4471Z",
    fill: "#3EC1D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethod);
export default __webpack_public_path__ + "static/media/method.b4c857f8dd98ab1067894e725cd2bd81.svg";
export { ForwardRef as ReactComponent };